
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_160_1676)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.588 17.647v3.529A2.825 2.825 0 0113.764 24H2.824A2.825 2.825 0 010 21.176v-10.94a2.825 2.825 0 012.824-2.824h3.529v7.762a2.473 2.473 0 002.473 2.473h7.762zM7.412 6.353V2.824A2.825 2.825 0 0110.236 0h10.94A2.825 2.825 0 0124 2.824v10.94a2.825 2.825 0 01-2.824 2.824h-3.529V8.826a2.473 2.473 0 00-2.473-2.473H7.412zm9.176 10.235H8.824c-.78 0-1.412-.633-1.412-1.412V7.412h7.764c.78 0 1.412.633 1.412 1.412v7.764zM8.824 8.824v4.94c0 .78.632 1.413 1.412 1.413h4.94V9.532a.709.709 0 00-.708-.708H8.824z","fill":"#BCB62D"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_160_1676"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    